import * as React from "react";
const SvgCharging = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M15 6.33438H13.7032V4.5H1V11.5H13.7032V9.65094H15V6.33438ZM12.8125 10.5993H1.875V5.37133H12.8125V10.5993Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M8.75 2L5 8.47888H7.25L6.25 14L10 7.52112H7.5L8.75 2Z",
	fill: "white"
}));
export default SvgCharging;
